/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/assets/js/product-quick-add.js ***!
  \********************************************/
// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(function () {
//     document.querySelectorAll('.product-card__quick-add-form').forEach(function (form) {
//       form.addEventListener('submit', function (event) {
//         event.preventDefault();
//         var productId = form.querySelector('input[name="id"]').value;
//         var quantity = form.querySelector('input[name="quantity"]').value;
//         var cartDrawer = document.querySelector('cart-drawer');
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             id: productId,
//             quantity: parseInt(quantity, 10)
//           })
//         }).then(function (response) {
//           if (!response.ok) {
//             return response.json().then(function (err) {
//               return Promise.reject(err);
//             });
//           }

//           return response.json();
//         }).then(function (data) {
//           Toastify({
//             text: "Product added to cart successfully",
//             duration: 1500,
//             className: "infoToast",
//             close: false,
//             gravity: "bottom",
//             position: "center",
//             stopOnFocus: true,
//             style: {
//               background: "#d54413"
//             }
//           }).showToast();
//           document.querySelector('zapiet-widget').reloadCart();
//         })["catch"](function (error) {
//           Toastify({
//             text: error.message || "Something went wrong",
//             duration: 1000,
//             close: false,
//             className: "infoToast",
//             gravity: "bottom",
//             position: "center",
//             stopOnFocus: true,
//             style: {
//               background: "#d54413"
//             }
//           }).showToast();
//         });
//       });
//     });
//   }, 500);
// });
// document.querySelectorAll('.add-to-cart-button button').forEach(function (button) {
//   button.addEventListener('click', function () {
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         id: button.getAttribute('data-variant-id'),
//         quantity: 1
//       })
//     }).then(function (response) {
//       if (!response.ok) {
//         return response.json().then(function (err) {
//           return Promise.reject(err);
//         });
//       }

//       return response.json();
//     }).then(function (data) {
//       button.parentElement.style.display = 'none';
//       button.closest('.product-smart-card__quick-add').querySelector('.quantity-selector').style.display = 'flex';
//       button.closest('.product-smart-card__quick-add').querySelector('.quantity-selector input').value = 1;
//       Toastify({
//         text: "Added to cart successfully",
//         duration: 1500,
//         close: false,
//         className: "infoToast",
//         gravity: "bottom",
//         position: "center",
//         stopOnFocus: true,
//         style: {
//           background: "#d54413"
//         }
//       }).showToast();
//       document.querySelector('zapiet-widget').reloadCart();
//     })["catch"](function (error) {
//       Toastify({
//         text: error.message || "Something went wrong",
//         duration: 1000,
//         close: false,
//         className: "infoToast",
//         gravity: "bottom",
//         position: "center",
//         stopOnFocus: true,
//         style: {
//           background: "#d54413"
//         }
//       }).showToast();
//     });
//   });
// });
// document.querySelectorAll('.quantity-selector .increase-qty, .quantity-selector .decrease-qty').forEach(function (button) {
//   button.addEventListener('click', function () {
//     var input = button.parentElement.querySelector('input');
//     var quantity = parseInt(input.value);

//     if (button.classList.contains('increase-qty')) {
//       quantity += 1;
//     } else {
//       quantity -= 1;
//     }

//     fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         id: button.getAttribute('data-variant-id'),
//         quantity: quantity
//       })
//     }).then(function (response) {
//       if (!response.ok) {
//         return response.json().then(function (err) {
//           return Promise.reject(err);
//         });
//       }

//       return response.json();
//     }).then(function (data) {
//       input.value = quantity;

//       if (quantity === 0) {
//         button.parentElement.style.display = 'none';
//         button.closest('.product-smart-card__quick-add').querySelector('.add-to-cart-button').style.display = 'block';
//       }

//       Toastify({
//         text: "Cart updated successfully",
//         duration: 1000,
//         close: false,
//         className: "infoToast",
//         gravity: "bottom",
//         position: "center",
//         stopOnFocus: true,
//         style: {
//           background: "#d54413"
//         }
//       }).showToast();
//       document.querySelector('zapiet-widget').reloadCart();
//     })["catch"](function (error) {
//       Toastify({
//         text: error.message || "Something went wrong",
//         duration: 1000,
//         close: false,
//         className: "infoToast",
//         gravity: "bottom",
//         position: "center",
//         stopOnFocus: true,
//         style: {
//           background: "linear-gradient(to right, #ff0000, #ff7a7a)"
//         }
//       }).showToast();
//     });
//   });
// });

// ✅ Prevent script from running twice when the section appears multiple times


// ✅ Prevent script from running twice when the section appears multiple times

// ✅ Prevent script from running twice when the section appears multiple times
if (window.__PRODUCT_CARD_HANDLERS__) {
  return;
}
window.__PRODUCT_CARD_HANDLERS__ = true;

// --- Delegated QUICK ADD form submit ---
document.addEventListener('submit', function (event) {
  const form = event.target.closest('.product-card__quick-add-form');
  if (!form) return;

  event.preventDefault();

  const productId  = form.querySelector('input[name="id"]').value;
  const quantity   = parseInt(form.querySelector('input[name="quantity"]').value, 10);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({id:productId, quantity:quantity})
  }).then(r=>r.json()).then(()=>{
    // update UI
    const wrap = form.closest('.product-smart-card__quick-add');
    if (wrap) {
      wrap.querySelector('.add-to-cart-button').style.display='none';
      wrap.querySelector('.quantity-selector').style.display='flex';
      wrap.querySelector('.quantity-selector input').value = quantity;
    }
    Toastify({
      text:"Added to cart successfully",
      duration:1500,
      gravity:"bottom",
      position:"center",
      className:"infoToast",
      style:{background:"#d54413"}
    }).showToast();
    document.querySelector('zapiet-widget').reloadCart();
  });
});


// --- Delegated CLICK events (Add and qty) ---
document.addEventListener('click', function (event) {
  // >>> ADD TO CART BUTTON (NOT in quick-add form)
  if (event.target.matches('.add-to-cart-button button')) {
    const addBtn = event.target;

    // If it's inside a quick-add form, let submit handler do the job
    if (addBtn.closest('.product-card__quick-add-form')) return;

    event.preventDefault();

    fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ id:addBtn.getAttribute('data-variant-id'), quantity:1 })
    }).then(r=>r.json()).then(()=>{
      addBtn.parentElement.style.display='none';
      addBtn.closest('.product-smart-card__quick-add').querySelector('.quantity-selector').style.display='flex';
      Toastify({
        text:"Added to cart successfully",
        duration:1500,
        gravity:"bottom",
        position:"center",
        className:"infoToast",
        style:{background:"#d54413"}
      }).showToast();
      document.querySelector('zapiet-widget').reloadCart();
    });

    return; // exit before qty section
  }

  // >>> QUANTITY BUTTONS
  const qtyBtn = event.target.closest('.quantity-selector .increase-qty, .quantity-selector .decrease-qty');
  if (qtyBtn) {
    event.preventDefault();

    const input = qtyBtn.parentElement.querySelector('input');
    let quantity = parseInt(input.value, 10);
    quantity += qtyBtn.classList.contains('increase-qty') ? 1 : -1;

    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ id:qtyBtn.getAttribute('data-variant-id'), quantity:quantity })
    }).then(r=>r.json()).then(()=>{
      if (quantity <= 0) {
        qtyBtn.parentElement.style.display='none';
        qtyBtn.closest('.product-smart-card__quick-add').querySelector('.add-to-cart-button').style.display='block';
      } else {
        input.value = quantity;
      }
      Toastify({
        text:"Cart updated successfully",
        duration:1000,
        gravity:"bottom",
        position:"center",
        className:"infoToast",
        style:{background:"#d54413"}
      }).showToast();
      document.querySelector('zapiet-widget').reloadCart();
    });
  }
});


  
/******/ })()
;